export interface SearchRequest {
	query: string;
	filters: string;
	attributesToRetrieve: string[];
	attributesToHighlight: string[];
	attributesToSnippet: string[];
	distinct: boolean | number;
	hitsPerPage: number;
	page: number;
	facets: string[];
}

export type Facets = Record<string, Record<string, number>>;

export type FacetsStats = Record<string, {
	min: number;
	max: number;
	avg: number;
	sum: number;
}>;

export interface SearchResponse<T extends Record<string, unknown> = { objectID: string }> {
	hits: T[];
	nbHits: number;
	page: number;
	nbPages: number;
	hitsPerPage: number;
	facets: Facets;
	facets_stats?: FacetsStats;
	exhaustiveFacetsCount: boolean;
	exhaustiveNbHits: boolean;
	exhaustiveTypo: boolean;
	exhaustive: {
		facetsCount: boolean;
		nbHits: boolean;
		typo: boolean;
	};
	query: string;
	params: string;
	renderingContent: Record<string, unknown>;
	processingTimeMS: number;
	processingTimingsMS?: {
		_request?: { roundTrip: number };
		extensions?: number;
		getIdx?: { load?: { total: number }; total?: number };
		total?: number;
		[k: string]: unknown;
	};
	serverTimeMS?: number;
}


export class AlgoliaClient {
	constructor(private apiKey: string, private appId: string, private index: string) {}

	async search<T extends Record<string, unknown>>(collectionId:string, size: number, page: number, filters: string[] = []): Promise<SearchResponse<T>> {
		let filterToApply: string[] = [];
		filterToApply.push(`collection_ids:${collectionId}`);
		filterToApply.push(...filters);

		const request: SearchRequest = {
			query: "",
			filters: filterToApply.join(" AND "),
			attributesToRetrieve: ["handle"],
			distinct: true,
			attributesToHighlight: [],
			attributesToSnippet: [],
			hitsPerPage: size,
			page: page,
			facets: ["*"]
		};

		console.log("Algolia search request:", request);


		const response = await fetch(`https://${this.appId}.algolia.net/1/indexes/${this.index}/query`, {
			method: "POST",
			headers: {
				"content-type": "application/json",
				"x-algolia-api-key": this.apiKey,
				"x-algolia-application-id": this.appId
			},
			body: JSON.stringify(request)
		});

		if (!response.ok) {
			const errorText = await response.text();
			throw new Error(`Algolia request failed (${response.status}): ${errorText}`);
		}

		const responseJson = await response.json() as Promise<SearchResponse<T>>;
		console.log("Algolia search response:", responseJson);

		return responseJson;
	}
}

